import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // ✅ ADICIONAR
import { FormsModule } from '@angular/forms';
import { DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

import { AppComponent } from './app.component';
import { HeaderComponent } from './Components/header/header.component';
import { FooterComponent } from './Components/footer/footer.component';
import { MainComponent } from './Components/main/main.component';
import { IpInfoComponent } from './Components/ip-info/ip-info.component';
import { LoaderModule } from 'src/modules/loader/loader.module';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './services/loader.service.interceptor';
import { environment } from 'src/environments/environment';

registerLocaleData(localePt);

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        MainComponent,
        IpInfoComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule, // ✅ CRITICAL - Necessário para animações do ngx-spinner
        AppRoutingModule,
        FontAwesomeModule,
        FormsModule,
        LoaderModule,
        NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: environment.clientId,
                authority: environment.authUrl,
                redirectUri: environment.redirect,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: isIE,
            },
        }), {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: [environment.interceptor],
            }
        }, {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: new Map([
                [environment.apiUrl, [environment.interceptor]],
            ]),
        })
    ],
    providers: [
        LoaderService,
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR'
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        MsalGuard,
        provideHttpClient(withInterceptorsFromDi()),
    ],
    bootstrap: [
        AppComponent,
        MsalRedirectComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
